import { Link } from "react-router-dom";
import SingleCheapAdvertCard from "../AdvertCard/SingleCheapAdvertCard";
import useEmlakjetProperties from "../../hooks/useEmlakjetProperties";
import {
  HOME_LISTINGS_PER_TYPE,
  homeListingSections,
} from "../../data/artemulkContent";
import { pickListingsByType } from "../../utils/pickListingsByType";
import "./home-listings.css";

const CARD_GRID_CLASS =
  "w-full min-w-0 max-w-full h-full shadow-light dark:border-card-dark border rounded-lg overflow-hidden relative group";

const HomeListingsByType = () => {
  const { data, isError, isLoading } = useEmlakjetProperties();

  if (isLoading || isError || !data?.length) {
    return null;
  }

  const sections = homeListingSections
    .map((section) => ({
      ...section,
      listings: pickListingsByType(
        data,
        section.match,
        HOME_LISTINGS_PER_TYPE
      ),
    }))
    .filter((section) => section.listings.length > 0);

  if (sections.length === 0) return null;

  return (
    <div className="px-[3%] md:px-[6%] pt-8 pb-16 border-t border-slate-200 dark:border-dark overflow-x-hidden max-w-full">
      {sections.map((section) => (
        <section key={section.id} className="mb-14 last:mb-0 home-listings-section">
          <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
            <h3 className="text-xl font-bold text-secondary dark:text-slate-200">
              {section.title}
            </h3>
            <Link
              to={section.to}
              className="text-sm font-medium text-primary hover:underline whitespace-nowrap"
            >
              Tümünü gör →
            </Link>
          </div>
          <div className="home-listings-flex items-stretch">
            {section.listings.map((card) => (
              <SingleCheapAdvertCard
                card={card}
                key={card.id}
                className={CARD_GRID_CLASS}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default HomeListingsByType;
